<template>
  <div class="navbar" :class="{navbarPopup: !closePage && closePopup}">
    <div class="navbar-inner no-swipeback" :class="{'navbar-inner-popup': !closePage && closePopup}" @click="closeCountryPickerModal">

      <!-- Menu "Hamburger" en haut à gauche des écrans de smartphones et tablette -->
      <f7-nav-left>
        <f7-link v-bind:style="{color: grey}" v-if="isSmallScreen"
          icon-fa="bars" color="#000000" close-picker open-panel="left" @click="updateNotifications">
        </f7-link>
        <f7-link v-else icon-fa="bars" style="color:#ffffff;width:79px"></f7-link>
      </f7-nav-left>

      <!-- Logo de MoneyRoad affiché sur écran mobile -->
      <div class="showSmallScreenOnly titleApp centrageLogoSmallScreen">
        <!-- La classe "streammind-icon-popup" est ajoutée s'il s'agit d'une fenêtre pop-up -->
        <p :class="{'streammind-icon-popup': closePopup}" @click="redirectionPage(service)">
          <f7-icon class="streammind-icon" v-bind:class="getColor"></f7-icon>
        </p>
      </div>

      <!-- TLV 14/11/2019 Logo de MoneyRoad affiché sur écran de PC -->
      <div class="showLargeScreenOnly">
        <!-- Logo de la navbar générale sur écran de PC, sur lequel l'utilisateur peut cliquer -->
        <p class="titleApp centrageLogoLargeScreen" @click="redirectionPage(service)" v-if="picker && !closePopup && service.length>4">
          <f7-icon class="streammind-icon" v-bind:class="getColor"></f7-icon>
        </p>
        <!-- Logo de la navbar des pop-up sur écran de PC -->
        <p class="titleApp" v-if="!closePage && closePopup">
          <f7-icon class="streammind-icon streammind-icon-popup" v-bind:class="getColor"></f7-icon>
        </p>
      </div>

      <!-- Bouton cancel pour fermer la fenêtre pop-up, à la fois pour le profile et le service switcher -->
      <div v-if="closePopup && !closePage" class="cancelButton">
        <f7-link class="streammindContactListButton orangeFont" close-popup>{{ $t('common.cncl') }}</f7-link>
      </div>
      <div v-else-if="closePage && !returnPreviousPage">
        <f7-link class="streammindContactListButton cancelButton orangeFont" @click="goBack()">{{ $t('common.cncl') }}</f7-link>
      </div>
      <div v-else-if="returnPreviousPage">
        <f7-link class="streammindContactListButton cancelButton orangeFont" @click="goBack()">{{ $t('common.rtrn') }}</f7-link>
      </div>
      <div v-else>
       <div style='min-width:44px;'/>
      </div>

      <!-- Bouton d'ouverture de pop-up de service switch-->
      <!-- Décommenter pour bloquer l'accès au service switcher pour les utilisateurs guest -->
      <f7-nav-right v-if="userIsGuest()">
        <f7-link no-link-class v-if="picker && !closePopup && !closePage && !returnPreviousPage"
          v-bind:style="{color: 'silver', backgroundColor: 'white'}" icon-fa="th"></f7-link>
      </f7-nav-right>
      <f7-nav-right v-else>
      <!-- TLV 21/08/2020 - Service switcher accessible uniquement pour les utilisateurs y ayant droit -->
      <f7-link v-if="picker && !closePopup && !closePage && !returnPreviousPage && $engine.user.validateAccess('serviceSwitcher')"
          v-bind:style="{color: grey}" close-picker icon-fa="th" open-popup data-popup="#service-switcher-true">
      </f7-link>
      </f7-nav-right>

      <!-- subnavbar des pop-up -->
      <f7-subnavbar v-if="subNavTitle !== '' && !closePage && closePopup"
                  :style="'border-bottom-color : ' + color"
                  class="subtitle subtitlePopup subnavbarPopup">
        <div v-if="!closePage && closePopup" class="subNavtitlePopup">{{subNavTitle}}</div>
      </f7-subnavbar>

      <!-- subnavbar des fenêtres sauf sur les pop-up -->
      <f7-subnavbar v-else-if="subNavTitle !== ''" :style="'border-bottom-color : ' + color" class="subtitle" >
        <!-- Bouton pour revenir en arrière sur smartphone -->
        <div class="returnButtonMarginLeft">
          <f7-link v-if="ReturnButton" v-bind:style="{color: grey}" close-picker @click="goBack()">
            <f7-icon f7="play_fill" style="transform: rotate(180deg);"></f7-icon>
          </f7-link>
        </div>
        <div class="subNavtitle">{{subNavTitle}}</div>
        <!-- Bouton d'aide s'il est demandé, sinon il est remplacé par un espace vide -->
        <div v-if="popoverName" class="popoverNamePaddingRight">
          <!-- User guide à mettre à jour -->
          <!-- <f7-link class="open-popover"
                  v-bind:style="{color: grey}"
                  href="#"
                  :data-popover="popoverName">
                  <f7-icon f7="help"></f7-icon>
          </f7-link> -->
        </div>
        <div v-else>
          <div style="margin-left:15px;"></div>
        </div>
      </f7-subnavbar>
    </div>
  </div>
</template>

<script>
import menuItem from '@/components/common/menuItem.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'navigationBar',
  data: () => {
    return {
      service: '',
      icon: '',
      color: '',
      windowWidth: window.innerWidth
    }
  },
  components: {
    'menu-item': menuItem
  },
  props: {
    currentServiceName: {
      type: String,
      default: ''
    },
    subNavTitle: {
      type: String,
      default: ''
    },
    menuAccess: {
      type: Boolean,
      default: false
    },
    closePopup: {
      type: Boolean,
      default: false
    },
    closePage: {
      type: Boolean,
      default: false
    },
    picker: {
      type: Boolean,
      default: true
    },
    returnPreviousPage: {
      type: Boolean,
      default: false
    },
    popoverName: {
      type: String,
      default: ''
    },
    backLink: {
      type: Boolean,
      default: false
    },
    ReturnButton: {
      type: Boolean,
      default: false
    },
    switchService: {
      type: Boolean,
      default: false
    }
  },
  created: function () {
    window.addEventListener('resize', this.handleResize)
    this.service = this.$engine.user.currentService.name

    this.icon = this.getIcon(this.service)
    this.color = this.getServiceColor(this.service)
    this.grey = '#404040'
    this.white = '#ffffff'
    if (this.windowWidth > 992) {
      this.updateNotifications()
    }
  },
  watch: {
  },
  mounted: function () {
    this.$bus.$on('service:change', (val) => {
      this.service = val
      if (this.service) {
        this.icon = this.getIcon(this.service)
        this.color = this.getServiceColor(this.service)
      }
    })
  },
  computed: {
    getColor: function () {
      return {
        'streammind-icon-purple': this.service === 'Direct Debit',
        'streammind-icon-green': this.service === 'Payments',
        'streammind-icon-blue': this.service === 'Direct Payments'
      }
    },
    isSmallScreen () {
      return this.windowWidth <= 992
    }
  },
  methods: {
    handleResize () {
      let that = this
      that.windowWidth = window.innerWidth
      that.$engine.services.directPayments.filter.smartphoneStorage = that.isSmallScreen
      that.$bus.emit('window-resize')
    },

    getIcon (service) {
      switch (service) {
        case 'Direct Debit':
          return 'icon-directDebit'
        /* case 'Direct Payments':
          return 'icon-directPayments' */
        case 'Payments':
          return 'icon-payments'
        default: // Direct Payments pour la démo
          return 'icon-directPayments'
      }
    },
    getServiceColor (service) {
      switch (service) {
        case 'Direct Debit':
          return '#572B74'
        case 'Payments':
          return '#51A45C'
        default: // Direct Payments pour la démo
          return '#12BCF1'
      }
    },
    closeCountryPickerModal () {
      this.$f7.closeModal('.countryListPicker')
    },
    showProfile () {
      loadPage(this, {url: '/profile/'})
    },
    activateModal () {
      this.$f7.popup('#service-switcher-true')
    },
    /* Ouverture du panneau de gauche (menu hamburger) et ajout des nombres de notifications */
    updateNotifications () {
      let that = this
      /** TLV 24/09/2019
      * Adaptation du modèle appelé en fonction du type de fonctionnalité sur le panneau de gauche
      * Payments --> Appel à payment/isRead
      * Direct Payments --> Appel à directPayment/isRead
      */
      if (this.$engine.user.currentService.name === 'Payments') {
        this.$engine.services.payments.getPaymentsNotReadNumber()
        .then(resp => {
          if (resp.data.requestNotReadNumber > 99) {
            that.Dom7('.numberBadge').text('99+')
          } else {
            that.Dom7('.numberBadge').text(resp.data.requestNotReadNumber)
          }
          /* eslint-disable no-undef */
          // Affichage des notifications sur mobile, provoque une erreur en console sur version web
          if (this.$engine.services.directPayments.filter.smartphoneStorage) {
            // cordova.plugins.notification.badge.set(resp.data.requestNotReadNumber)
          }
          /* eslint-enable no-undef */
        })
        .catch(error => {
          // console.log(error)
          errorMessageAlert(error, that)
        })
      } else if (this.$engine.user.currentService.name === 'Direct Payments') {
        this.$engine.services.directPayments.getPaymentsNotReadNumber()
        .then(resp => {
          if (resp.data.requestNotReadNumber > 99) {
            that.Dom7('.numberBadge').text('99+')
          } else {
            that.Dom7('.numberBadge').text(resp.data.requestNotReadNumber)
          }
          /* eslint-disable no-undef */
          // Affichage des notifications sur mobile, provoque une erreur en console sur version web
          if (this.$engine.services.directPayments.filter.smartphoneStorage) {
            // cordova.plugins.notification.badge.set(resp.data.requestNotReadNumber)
          }
          /* eslint-enable no-undef */
        })
        .catch(error => {
          // console.log(error)
          errorMessageAlert(error, that)
        })
      } else if (this.$engine.user.currentService.name === 'Direct Debit') {
        this.$engine.services.directDebit.getPaymentsNotReadNumber()
        .then(resp => {
          this.$bus.emit('updateNotificationNumber', resp.data.requestNotReadNumber)
          /* eslint-disable no-undef */
          // Affichage des notifications sur mobile, provoque une erreur en console sur version web
          if (this.$engine.services.directPayments.filter.smartphoneStorage) {
            // cordova.plugins.notification.badge.set(resp.data.requestNotReadNumber)
          }
          /* eslint-enable no-undef */
        })
        .catch(error => {
          // console.log(error)
          errorMessageAlert(error, that)
        })
      }
    },
    /* GGA - repris par TLV le 27/12/2019
    * Fonction qui gère le retour en arrière de la flèche noire sur mobile
    */
    goBack () {
      if (this.$f7.mainView.history[this.$f7.mainView.history.length - 2] !== '/login/' ||
          this.$f7.mainView.history[this.$f7.mainView.history.length - 1] === '/register/') {
        // Liste des URL "qui posent problème" (celles où le goback créer un bug d'écran noir)
        if (this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === '/payments/newPayments/' ||
            this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === '/payments/negotiate/' ||
            this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === '/payments/draft/edit/' ||
            this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === '/accountMembers/edit/' ||
            this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === '/accountMembers/add/' ||
            this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === '/attachments/import/' ||
            this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === '/attachments/createInvoice/' ||
            this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === '/attachments/createInvoice//' ||
            this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === '/bankAccounts/create/' ||
            this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === '/bankAccounts/modify/' ||
            this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === '/account/addContact/' ||
            this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === '/account/editContact/' ||
            this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === '/account/addContactGroup/' ||
            this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === '/account/editContactGroup/' ||
            this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === '/settings/remind/add/' ||
            this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === '/settings/remind/edit/' ||
            this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === '/profile/edit/' ||
            this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === '/account/editMembersGroup/' ||
            this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === '/accountMembers/addMemberGroupMembersList/' ||
            this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === '/profile/changePassword/') {
          // Change history
          /* this.$f7.mainView.history.pop()

          // Change pages
          this.$$(this.$$('.page.page-on-left')[this.$$('.page.page-on-left').length - 1]).remove()
          this.$$(this.$$('.page.page-on-left.cached')[this.$$('.page.page-on-left.cached').length - 1]).removeClass('cached')

          // Change navbar
          this.$$(this.$$('.navbar-inner.navbar-on-left')[this.$$('.navbar-inner.navbar-on-left').length - 1]).remove()
          this.$$(this.$$('.navbar-inner.navbar-on-left.cached')[this.$$('.navbar-inner.navbar-on-left.cached').length - 1]).removeClass('cached')
          this.$$(this.$$('.navbar-inner.navbar-on-left')[this.$$('.navbar-inner.navbar-on-left').length - 1]).removeClass('navbar-on-left')
          this.$$(this.$$('.navbar-inner')[this.$$('.navbar-inner').length - 1]).addClass('navbar-on-center')

          this.$f7.mainView.router.back() */
          this.$f7.alert('', 'Fail')
        } else {
          // console.log(this.$f7.mainView)
          this.$f7.mainView.router.back()
        }
      }
    },
    /* TLV 09/12/2019
    * Fonction qui redirige l'utilisateur en fonction du service qu'il utilise
    */
    redirectionPage (service) {
      let link = ''

      switch (service) {
        case 'Payments' :
          link = '/dashboard/'
          break
        case 'Direct Payments' :
          link = '/directPayments/inbox/'
          break
        case 'Direct Debit' :
          link = '/directDebit/inbox/'
          break
        default :
          break
      }
      // TLV 25/11/2019 : Bouton de déconnexion depuis la navbar
      if (service === '') {
        this.$bus.emit('logout')
      }
      // Autres boutons de la navbar
      loadPage(this, {url: link})
    }
  }
}
</script>

<style>
.returnButtonMarginLeft {
  margin-left:14px
}
.popoverNamePaddingRight {
  padding-right:6px;
  /* margin-left:15px; */
}
.icon-payments {
  background-image: url('../../assets/static/images/logo/payments.png');
}
.icon-directDebit {
  background-image: url('../../assets/static/images/logo/SEPA.png');
}
/* Direct Payments */
.icon-directPayments {
  background-image: url('../../assets/static/images/logo/exchangeDoc.png');
}
.primary-icon {
  width: 45px;
  height: 45px;
  background-size: contain;
  display: inline-block !important;
  cursor: pointer;
}



/** TLV 25/11/2019
* Le logo de MoneyRoad est petit sur smartphone, grand sur navigateur Web
*/
@media (max-width: 768px) {
  .navbarPopup {
    height: 15%;
    margin-top: -5%;
  }
  .subNavtitle {
      margin-left: 13px;
  }
}
@media (min-width: 768px) and (max-width: 992px) {
  .navbarPopup {
    height: 21%;
    margin-top: -7%;
  }
}

@media (max-width:768px){
  .subtitlePopup{
    margin-top: -7.5px !important;
  }
}
@media (min-width:768px) AND (max-width:992px){
  .subtitlePopup{
    /* TLV 27/12/2019 : Remplacement de ce margin de la fenêtre modale sur certaines tailles d'écran
    * pour éviter un bug d'affichage sur la tablette Galaxy S4 */
    margin-top: -42px !important;
  }
}
@media (max-width:993px) {
  .subtitle {
      margin: -1.35%;
      width: 102%;
  }
  .streammind-icon {
    width: 130px;
    height: 60px;
    background-size: contain;
  }

  .elsepadding {
    display:none !important;
  }

  .subNavtitlePopup {
    margin-left: 36%;
  }
  .subtitlePopup{
    height: 27px !important;
  }
  .streammind-icon-popup {
    margin-left: 17% !important;

  }

  .navbar-inner-popup {
    height: 96% !important;
    margin-top: 1%;
    margin-bottom: 5%;
  }
}

@media (min-width:993px) {
  /* TLV 12/12/2019 : la margin passe de -1.35% à -27px sur écran de bureau pour un meilleur affichage des filter */
  .subtitle {
      height: 26.6px;
      margin: -26px -1.35% 0 -1.35%;
      width: 102%;
  }
  .streammind-icon {
    width: 400px;
    height: 94px;
    background-size: contain;
    cursor: pointer;
    /* margin-left: 75%; */
  }

  .navbar {
     height: 123px;
     position: absolute;
  }

  .bottomToolbarContainer {
    display:none;
  }

  .subNavtitle {
      margin-left: calc(300px + 3%);
      font-size: 16px;
  }

  /* TLV 27/11/2019 : on supprime le bouton "Back" sur ordi, qui cause des bugs */
  .returnButtonMarginLeft {
   margin-left: -50px;
  }

  /* TLV 28/11/2019 : on supprime le menu hamburger des fenêtres sur grand écran*/
  .fa-bars{
    display:none !important;
  }
  .subNavtitlePopup {
    margin-left: 40%;
  }
  .subtitlePopup{
    /* TLV 26/12/2019 : suppression de cette classe qui cause un problème d'affichage sur écran de tablette */
    /* margin-top: -4.35% !important; */
  }
  .streammind-icon-popup {
    margin-left: auto !important;
  }
}
.streammind-icon-purple {
  background-image: url('../../assets/static/images/logo/moneyroad_purple.svg');
}
.streammind-icon-green {
  background-image: url('../../assets/static/images/logo/moneyroad_green.svg');
}
.streammind-icon-blue {
  background-image: url('../../assets/static/images/logo/moneyroad_blue.svg');
}
.streammind-navicon-moneyroad {
  background-image: url('../../assets/static/images/logo/mrlogo.png');
}
:root {
  --f7-navbar-bg-color: red;
}
</style>



// WEBPACK FOOTER //
// pageNavBar.vue?0956b372